<template>
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%; background-color:#fff;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
                       placeholder="请输入审批说明"/>
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交
          </van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames">
      <div style="padding-left: 16px">
        <van-field v-model="inputForm.transferTypeLabel" label="换装单类型" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.transferCode" label="换装单编号" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.code" label="车辆到达市场单据编号" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.createByName" label="制单人" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.createDate" label="制单日期" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      </div>
      <template v-if="inputForm.salesDepartInfoList && inputForm.salesDepartInfoList.length">
      <div v-for="(sdInfo, sdIndex) in inputForm.salesDepartInfoList" :key="sdIndex">
        <div class="title">境内发车信息（{{ sdInfo.salesDepartCode }}）</div>
        <van-field v-model="sdInfo.salesDepartCode" label="销售发车单编号" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="sdInfo.productName" label="商品名称" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="sdInfo.domesticConsignName" label="境内发车地点" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="sdInfo.domesticDepartureDate" label="境内发车日期" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="sdInfo.domesticDepartTripNo" label="境内发车车次" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="sdInfo.domesticPlateNo" label="境内运输车牌号" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="sdInfo.domesticTruckNum" label="发车件数（筐）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="sdInfo.domesticTotalWeightIncludePack" label="发车含筐总重（斤）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="sdInfo.domesticAvgWeightIncludePack" label="发车单筐含筐均重（斤）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="sdInfo.domesticTotalWeightExcludePack" label="发车不含筐总重（斤）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="sdInfo.domesticAvgWeightExcludePack" label="发车单筐不含筐均重（斤）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <b-table class="bgc-dark" head-variant="dark" responsive bordered
                 :items="sdInfo.domesticDetailList" :fields="fields1">
          <template v-slot:head()="scope">
            <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
              {{ scope.label }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(totalWeightIncludePack)="data">
            {{ Number(data.item.totalWeightIncludePack).toFixed(2) }}
          </template>

          <template v-slot:table-colgroup="scope">
            <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.width }"
            >
          </template>
        </b-table>
        <div class="title">口岸换装信息</div>
        <van-field v-model="sdInfo.transferDate" label="口岸换装日期" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="sdInfo.internationalPlateNo" label="国际运输车牌号" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="sdInfo.totalNum" label="口岸换装总件数（筐)" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="sdInfo.totalWeight" label="口岸换装含筐总重（斤）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="sdInfo.averageWeightPerBasket" label="单筐均重（斤）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="sdInfo.transferTotalWeightExcludePack" label="换装不含筐总重（斤）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="sdInfo.transferAvgWeightExcludePack" label="换装不含框净果均重（斤/件）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <b-table class="bgc-dark" head-variant="dark" responsive bordered
                 :items="sdInfo.transferDetailList" :fields="fields2">
          <template v-slot:head()="scope">
            <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
              {{ scope.label }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(totalWeightIncludePack)="data">
            {{ Number(data.item.totalWeightIncludePack).toFixed(2) }}
          </template>

          <template v-slot:table-colgroup="scope">
            <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.width }"
            >
          </template>
        </b-table>
      </div>
      </template>
      <van-collapse-item  v-if="inputForm.transferType === '1'" title="国际段二次换装信息" name="4">
        <van-field v-model="inputForm.transferSecondInfo.transferDate" label="二次换装日期" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.transferSecondInfo.internationalPlateNo" label="国际运输车牌号" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.transferSecondInfo.totalNum" label="二次换装总件数（筐）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.transferSecondInfo.totalWeight" label="二次换装含筐总重（斤）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.transferSecondInfo.transferPlaceName" label="二次换装地点" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.transferSecondInfo.secondAvgWeightIncludePerBasket" label="二次换装单筐含筐均重（斤/件）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.transferSecondInfo.secondTotalWeightExcludePack" label="二次换装不含筐总重（斤）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.transferSecondInfo.secondAvgWeightExcludePerBasket" label="二次换装单筐不含筐均重（斤/件）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <b-table class="bgc-dark" head-variant="dark" responsive bordered
                 :items="inputForm.transferSecondInfo.detailList2" :fields="fields3">
          <template v-slot:head()="scope">
            <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
              {{ scope.label }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(totalWeightIncludePack)="data">
            {{ Number(data.item.totalWeightIncludePack).toFixed(2) }}
          </template>

          <template v-slot:table-colgroup="scope">
            <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.width }"
            >
          </template>
        </b-table>
      </van-collapse-item>
      <van-collapse-item title="车辆到达市场信息" name="5">
        <van-field v-model="inputForm.countryName" label="市场所属国家" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.salesPlaceName" label="销售地点" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.arrivalDate" label="到达市场时间" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.arrivalTripNo" label="到达市场车次" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.arrivalTotalNum" label="车辆到达市场总件数（筐）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.arrivalTotalWeight" label="车辆到达市场含筐总重（斤）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.averageWeightPerBasket" :formatter="formatter" label="单筐均重（斤）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.arrivalTotalWeightExcludePack" label="车辆到达市场不含筐总重（斤）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.arrivalAvgWeightExcludePerBasket" label="车辆到达市场单筐不含筐均重（斤/件）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <b-table v-show="inputForm.arrivalDetailList&&inputForm.arrivalDetailList.length>0" class="bgc-dark" head-variant="dark" responsive bordered
                 :items="inputForm.arrivalDetailList" :fields="fields4">
          <template v-slot:head()="scope">
            <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
              {{ scope.label }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(totalWeightIncludePack)="data">
            {{ Number(data.item.totalWeightIncludePack).toFixed(2) }}
          </template>

          <template v-slot:table-colgroup="scope">
            <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.width }"
            >
          </template>
        </b-table>
        <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.attachList.length > 0">
          <p style="color: #AAA">到达市场国际运输车辆拍照上传</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
        <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.marketReceiptAttachList && inputForm.marketReceiptAttachList.length > 0">
          <p style="color: #AAA">市场收货单附件上传</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.marketReceiptAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
        <van-field v-model="inputForm.remark" label="备注" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />

      </van-collapse-item>
    </van-collapse>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>


<script>
import processRecord from "../../../../../components/processRecord/processRecord.vue";
import TaskService from "../../../../../api/flowable/TaskService";
import ProcessService from "../../../../../api/flowable/ProcessService";
import QueryInfoService from "@/api/system/queryInfoService";
import {Decimal} from "decimal.js";

export default {
  name: "ItsLogisticMarketArrival",
  data() {
    return {
      activeNames: ['1', '2', '3', '4', '5'],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type: '',
      inputForm: {
        carFrontAttachList: [],
        carBodyAttachList: [],
        carTailAttachList: [],
        attachList: [],
        marketReceiptAttachList: [],
        isDoTask: false,
        isLastTask: false,
      },
      flowTable: 'its_logistic_market_arrival',
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'fruitTypeLabel', label: '果品类型', width: '120px'},
        {key: 'brandName', label: '产品品牌', width: '120px'},
        {key: 'varietyLevelLabel', label: '产品等级', width: '120px'},
        {key: 'truckNum', label: '发车件数（筐）', width: '120px'},
        {key: 'totalWeightIncludePack', label: '发车含筐总重（斤）', width: '120px'},
        {key: 'totalWeightIncludePack', label: '标准包装材料重量（斤/件）', width: '120px'},
        {key: 'totalWeightExcludePack', label: '发车不含筐总重（斤）', width: '120px'},
        {key: 'avgWeightIncludePack', label: '发车单筐含筐均重（斤/件）', width: '140px'},
        {key: 'avgWeightExcludePack', label: '发车单筐不含筐均重（斤/件）', width: '140px'},
      ],
      fields2: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'fruitTypeLabel', label: '果品类型', width: '120px'},
        {key: 'brandName', label: '产品品牌', width: '120px'},
        {key: 'varietyLevelLabel', label: '产品等级', width: '120px'},
        {key: 'num', label: '口岸换装件数（筐）', width: '120px'},
        {key: 'totalWeightIncludePack', label: '口岸换装含筐总重（斤）', width: '120px'},
      ],
      fields3: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'fruitTypeLabel', label: '果品类型', width: '120px'},
        {key: 'brandName', label: '产品品牌', width: '120px'},
        {key: 'varietyLevelLabel', label: '产品等级', width: '120px'},
        {key: 'num', label: '二次换装件数（筐）', width: '120px'},
        {key: 'totalWeightIncludePack', label: '二次换装含筐总重（斤）', width: '120px'},
      ],
      fields4: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'fruitTypeLabel', label: '果品类型', width: '120px'},
        {key: 'brandName', label: '产品品牌', width: '120px'},
        {key: 'varietyLevelLabel', label: '产品等级', width: '120px'},
        {key: 'truckNum', label: '车辆到达市场件数（筐）', width: '120px'},
        {key: 'totalWeightIncludePack', label: '车辆到达市场含筐总重（斤）', width: '120px'},
      ],
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById(id, '/its/logistic/itsLogisticMarketArrival/queryById').then(({data}) => {
        this.inputForm = data
        this.inputForm.createDate = data.createDate.slice(0,10)
        this.getDict([
          ['its_transfer_type', 'transferType'],
        ])
        if(data.salesDepartInfoList && data.salesDepartInfoList.length > 0) {
          data.salesDepartInfoList.forEach(item => {
            this.updateDictNames(item.domesticDetailList,{
              its_fruit_type:'fruitType',
              its_base_variety_level:'varietyLevel'
            })
            this.updateDictNames(item.transferDetailList,{
              its_fruit_type:'fruitType',
              its_base_variety_level:'varietyLevel'
            })
          })
        }
        this.updateDictNames(this.inputForm.transferSecondInfo.detailList2,{
          its_fruit_type:'fruitType',
          its_base_variety_level:'varietyLevel'
        })
        this.updateDictNames(this.inputForm.arrivalDetailList,{
          its_fruit_type:'fruitType',
          its_base_variety_level:'varietyLevel'
        })
      }).catch(e => {
        console.log(e)
      })
    },
    async updateDictNames(dataList, dictTypeList) {
      const {data} = await new QueryInfoService().getDictMap();
      const promises = dataList.map(async (item) => {
        for (const [dictType, formField] of Object.entries(dictTypeList)) {
          if (data[dictType] && Array.isArray(data[dictType])) {
            const dictItem = data[dictType].find(d => d.value === item[formField]);
            if (dictItem) {
              this.$set(item, `${formField}Label`, dictItem.label);
            }
          }
        }
      })
    },
    getDict(dicts) {
      new QueryInfoService().getDictMap().then(({data}) => {
        dicts.map(([dictType, formField]) => {
          this.$set(this.inputForm, `${formField}Label`, data[dictType].find(item => item.value == this.inputForm[formField]).label);
        });
      }).catch(e => {
        console.log(e)
      })
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(2, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
    close() {
      if (this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        // vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask ? '_flow_approval' : '_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          let form = {
            id: _this.inputForm.id,
            flowType: _this.inputForm.isLastTask ? 4 : 2,
            formKey: _this.formKey,
            flowTable: _this.flowTable,
          }
          // _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          _this.$flow.startFlow(form, '/its/comm/flow/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          // _this.inputForm.flowType = 3;
          let form = {
            id: _this.inputForm.id,
            flowType: 3,
            formKey: _this.formKey,
            flowTable: _this.flowTable,
          }
          _this.$flow.startFlow(form, '/its/comm/flow/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    formatter(value) {
      return Number(value).toFixed(2)
    },
    viewDetail() {
      this.$router.push({
        path: '/ItsLaborDailyDetail',
        query: {
          data: JSON.stringify(this.inputForm.dailyDetailList1)
        }
      })
    },
    showDetail(content) {
      if(content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
  }
}
</script>

<style scoped>
.title {
  font-size: 14px;
  font-weight: bold;
  color: #323233;
  padding: 12px 16px;
  background-color: #f7f8fa;
  border-left: 3px solid #1989fa;
  margin-bottom: 8px;
}

::v-deep .van-collapse-item__content {
  padding-bottom: 10px;
}
</style>
